import { useQueryClient } from '@tanstack/react-query'
import { useCallback } from 'react'
import { getListApiV1NotificationsFeedUserEventListGetQueryKey } from '../gen/base'

export const useInvalidateNotificationsFeedUserEventListQuery = () => {
    const queryClient = useQueryClient()

    return useCallback(() => {
        queryClient.invalidateQueries({
            predicate: (query) =>
                query.queryKey.some(
                    (key) =>
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        //@ts-expect-error
                        key?.url === getListApiV1NotificationsFeedUserEventListGetQueryKey()[0].url,
                ),
        })
    }, [queryClient])
}
